import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import AddIcon from '@mui/icons-material/Add';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import FilterAltOffIcon from '@mui/icons-material/FilterAltOff';
import SyncIcon from '@mui/icons-material/Sync';
import { iconButtonStyle } from 'pages/DashboardHelpers';
import { clearOcplcFilters } from 'actions/ocplcAction';
import { actionButtonsStyle } from 'pages/ocplcDashboard/ocplcHelpers';
import { handleUnauthorizedAccess, isAddDisabled, isCopyDisabled, isDeleteDisabled } from 'pages/Utils/OcplcUtil';
import DeleteDialog from 'pages/OcplcEditDashboard/OcplcDialog/DeleteDialogOcplc';
import AddDialog from 'pages/OcplcEditDashboard/OcplcDialog/AddDialogOcplc';
import EditOcplc from 'pages/OcplcEditDashboard/CopyEditAudit/EditOcplc';
import { LOC_CHOICE_ID, LOC_MAPPING, LOCK_STATUS_DASHBOARD, OCPLC_ADMIN, REGION_WW, TOF_PROGRAM_MANAGEMENT } from 'constants/ocplcConstants';
import { snackBar } from 'actions/modelActions';
import { IconButton, Tooltip } from '@mui/material';
import ConfirmationDialog from 'components/ConfirmationDialog';

const ActionableButtons = (props) => {
    const { version, region, kmatId, productLineID, productGroup, checkedRow, userEmail, businessModels, assignedRole, countryList, disabledAction, setCheckedRow, selectedCategory, setLockModel, tableConfig, selectedTable, filterKmats, categories, filterOcplcKmatForPG, selectedProductGroup, regionDropdown, filteredModelData, setSelectedIds } = props;
    const dispatch = useDispatch();
    const [dialogState, setDialogState] = useState({
        isDeleteDialogOpen: false,
        isAddDialogOpen: false,
        isCopyDialogOpen: false
    });

    const [formData, setFormData] = useState({});
    const [ConfirmDialog, setConfirmationDialog] = useState({ open: false, message: '', onConfirm: null });

    const isParameters = [TOF_PROGRAM_MANAGEMENT,LOC_CHOICE_ID,LOC_MAPPING].includes(selectedTable);

    const refreshAction = () => {
      const params = tableConfig.getParams({ version, region, kmatId, productGroup, productLineID, selectedCategory, selectedProductGroup });
      tableConfig.loadData(dispatch, params);
    };
  
    const clearFilterAction = () => {
      setCheckedRow([]);
      setSelectedIds([]);
      dispatch(clearOcplcFilters());
    };

  const handleKmatLocking = async (dialog) => {
    const isNoChoice = checkedRow[0]?.choiceId?.startsWith("NOCHOICE");
    const isWWRecord = checkedRow[0]?.region === REGION_WW;
    if (checkedRow[0]?.regionLock &&( isNoChoice || isWWRecord)) {
      if(dialog === "isCopyDialogOpen"){
         dispatch(snackBar(true, `Regional lock set for the material cannot be copied.`));
      }else{
        dispatch(snackBar(true, `The world-wide record is locked by ${checkedRow[0]?.whoChanged}, It only allow to copy after unlocked.`));
      }
    } else {
      const { whoChanged, status, productFamily } = checkedRow[0];
      const unAuthorize = handleUnauthorizedAccess(userEmail, whoChanged, setLockModel, status, filterKmats, productFamily,assignedRole);
      if (unAuthorize) return;
      handleDialogOpen(dialog);
    }
  };

    const handleDialogOpen = (dialog) => {
        setDialogState(prev => ({ ...prev, [dialog]: true }));
    };

    const handleDialogClose = (dialog) => {
        dispatch({ type: LOCK_STATUS_DASHBOARD, payload: {} });
        setDialogState(prev => ({ ...prev, [dialog]: false }));
    };

    const handleDelete = (dialog)=>{
      if(isParameters){
        handleDialogOpen(dialog);
      }else{
        handleKmatLocking(dialog)
      }
    }

    const isCopyButtonDisabled = isCopyDisabled(version, assignedRole, region, checkedRow,selectedTable);
    const isAddButtonDisabled = isAddDisabled(version, assignedRole, region,kmatId,selectedTable,checkedRow.length)
    const isDeleteButtonDisabled = isDeleteDisabled(version, assignedRole, region, checkedRow, selectedTable,userEmail);

    const actionsLeft = [
      { label: 'Add', icon: <AddIcon />, onClick: () => handleDialogOpen('isAddDialogOpen'), disabled: isAddButtonDisabled  },
      { label: 'Copy', icon: <ContentCopyIcon />, onClick: () => handleKmatLocking('isCopyDialogOpen'), disabled: isCopyButtonDisabled  },
      { label: 'Delete', icon: <DeleteForeverIcon />, onClick: () => handleDelete('isDeleteDialogOpen'), disabled: isDeleteButtonDisabled }
    ];

    const actionsRight = [
        { label: 'Clear Filters', icon: <FilterAltOffIcon />, onClick: clearFilterAction },
        { label: 'Refresh', icon: <SyncIcon />, onClick: refreshAction }
    ];

    return (
      <>
      <Box sx={actionButtonsStyle}>
        <Box sx={{ display: "inline-flex", gap: "10px" }}>
          {actionsLeft.map(({ label, icon, onClick, disabled }) => (
            <Tooltip key={label} title={label}>
              <span>
                <IconButton
                  color="primary"
                  sx={iconButtonStyle}
                  disabled={disabled}
                  onClick={onClick}
                >
                  {icon}
                </IconButton>
              </span>
            </Tooltip>
          ))}
        </Box>
        <Box sx={{ display: "inline-flex", gap: "10px" }}>
          {actionsRight.map(({ label, icon, onClick }) => (
            <Tooltip key={label} title={label}>
              <span>
                <IconButton
                  color="primary"
                  sx={iconButtonStyle}
                  onClick={onClick}
                >
                  {icon}
                </IconButton>
              </span>
            </Tooltip>
          ))}
        </Box>
      </Box>
        
        {dialogState.isDeleteDialogOpen && (
          <DeleteDialog
            isOpen={dialogState.isDeleteDialogOpen}
            handleClose={() => handleDialogClose('isDeleteDialogOpen')}
            checkedRow={checkedRow}
            selectedTable={selectedTable}
            setCheckedRows={setCheckedRow}
            setSelectedIds={setSelectedIds}
          />
        )}
       
        {dialogState.isAddDialogOpen && (
          <AddDialog
            filterOcplcKmatForPG={filterOcplcKmatForPG}
            open={dialogState.isAddDialogOpen}
            onClose={() => handleDialogClose('isAddDialogOpen')}
            version={version}
            region={region}
            countryList={countryList}
            productGroup={productGroup}
            userEmail={userEmail}
            kmatId={kmatId}
            businessModels={businessModels}
            productLineID={productLineID}
            setCheckedRows={setCheckedRow}
            selectedTable={selectedTable}
            categories={categories}
            checkedRow={checkedRow[0]}
            filterKmats={filterKmats}
            selectedCategory={selectedCategory}
            regionDropdown={regionDropdown}
            setSelectedIds={setSelectedIds}
            getFormData={setFormData}
            getConfirmationDialog={setConfirmationDialog}
          />
        )}

        {dialogState.isCopyDialogOpen && (
          <EditOcplc
            open={dialogState.isCopyDialogOpen}
            handleClose={() => handleDialogClose('isCopyDialogOpen')}
            mode="copy"
            plcDetails={checkedRow[0]}
            selectedCategory={selectedCategory}
            productGroupDashboard={productGroup}
            countryList={countryList}
            businessModels={businessModels}
            selectedTableRegion={region}
            userEmail={userEmail}
            disabledAction={disabledAction}
            assignedRole={assignedRole}
            kmatId={kmatId}
            productLineID={productLineID}
            copy={true}
            setCheckedRows={setCheckedRow}
            selectedTable={selectedTable}
            setSelectedIds={setSelectedIds}
            getFormData={setFormData}
            getConfirmationDialog={setConfirmationDialog}
          />
      )}

      {ConfirmDialog.open && (
        <ConfirmationDialog
          open={ConfirmDialog.open}
          content={ConfirmDialog.message}
          onConfirm={() => {
            ConfirmDialog.onConfirm();
            setConfirmationDialog({ open: false, message: '', onConfirm: null });
          }}
          onClose={() => setConfirmationDialog({ open: false, message: '', onConfirm: null })}
          caption="Confirm"
          bgColor="#1976d2"
        />  
      )}
      </>
    );
};

export default ActionableButtons;